import { useQueryClient } from "@tanstack/react-query";
import { tokenManager } from "lib/tokenManager";
import { API_BASE } from "../config";

export const useLogOut = () => {
    const queryClient = useQueryClient();

    return () => {
        // Revoke the session server-side (PRTL-1356) BEFORE dropping the
        // token locally. Raw fetch with an explicit header + keepalive on
        // purpose: a trpc mutation here loses a race with the client rebuild
        // that clearing the token triggers (and queryClient.clear() can
        // cancel it), and keepalive lets the request survive the page
        // navigation that follows logout.
        const token = tokenManager.get();
        if (token) {
            void fetch(`${API_BASE}/trpc/auth.logout?batch=1`, {
                method: "POST",
                keepalive: true,
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({ 0: { json: null } }),
            }).catch(() => {
                // Fire-and-forget: local logout must not depend on the network.
            });
        }

        tokenManager.set(null);

        // Invalidate all queries across all routers to clear cached data
        queryClient.clear();
    };
};
